import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import HeartBrokenOutlinedIcon from "@mui/icons-material/HeartBrokenOutlined";

const LikeDislikeButtons = ({
  likeCount,
  dislikeCount,
  likeStatus,
  handleLike,
  handleDislike,
  theme,
}) => {
  const handleLikeClick = () => {
    // Toggle the like status: if already liked, set to neutral; otherwise, set to like
    handleLike(likeStatus === "like" ? null : "like");
  };

  const handleDislikeClick = () => {
    // Toggle the dislike status: if already disliked, set to neutral; otherwise, set to dislike
    handleDislike(likeStatus === "dislike" ? null : "dislike");
  };

  return (
    <Grid item>
      <IconButton
        onClick={handleLikeClick}
        sx={{
          color: likeStatus === "like" ? theme.colors.green : "inherit", // Set color based on status
        }}
      >
        <FavoriteBorderOutlinedIcon />
      </IconButton>
      <Typography
        variant="body2"
        sx={{ display: "inline", color: theme.colors.darkGray }}
      >
        Like {likeCount}
      </Typography>

      <IconButton
        onClick={handleDislikeClick}
        sx={{
          color: likeStatus === "dislike" ? theme.colors.red : "inherit", // Set color based on status
        }}
        style={{ marginLeft: "16px" }}
      >
        <HeartBrokenOutlinedIcon />
      </IconButton>
      <Typography
        variant="body2"
        sx={{ display: "inline", color: theme.colors.darkGray }}
      >
        Dislike {dislikeCount}
      </Typography>
    </Grid>
  );
};

export default LikeDislikeButtons;
